import React, {Fragment} from "react";
import {Route} from "react-router-dom";
import {
	arrayToObject,
	changeState,
	forEachObj,
	mapArrayToObject,
	mapObjectToArray,
	objectMerge, objLength,
	saveMessage,
} from "../lib/tools";
import {Checkbox, DropDown} from "../components/common/formValidation";
import {Button, RelativeSwitch} from "../components/common/common";
import {reduxWrapper} from "../globalState";
import {VendorOverview} from "./vendorTool";

const ImportTool = () => (
	<div id="importTool">
		<RelativeSwitch>
			<Route path=":vendor"
			       render={({match: {params: {vendor}}}) => <ImportAttributeView vendor={vendor}/>}/>
			<Route component={VendorOverview}/>
		</RelativeSwitch>
	</div>
);

const {Provider: AttributeProvider, Consumer: AttributeConsumer} = React.createContext({});

class ImportAttributeViewRender extends React.Component {
	constructor(props) {
		super(props);
		
		this.onAddType = name => {
			return new Promise((resolve, reject) => {
				this.props.addProductTypes({data: {name}, success: data => resolve(data.id)})
			})
		};
		
		this.onAddAttribute = name => {
			return new Promise((resolve, reject) => {
				this.props.addAttributes({data: {name}, success: data => resolve(data.id)})
			})
		};
		
		this.onAttributeChange = (id, val) => {
			this.setState(changeState(["attributes", id, "attributeLink"], val))
		};
		
		this.onConfChange = (id, val) => {
			this.setState(changeState(["attributes", id, "isConfig"], val))
		};
		
		this.onSectionChange = (id, child, val) => {
			this.setState(changeState(["attributes", id, "options", child, "sectionId"], val))
		};
		
		this.onTypeChange = (id, child, val) => {
			this.setState(changeState(["attributes", id, "options", child, "typeId"], val))
		};
		
		this.onSave = () => {
			this.props.apiCall("PUT", "/admin/import/attributes", data => this.props.sendMessage(saveMessage()), {list: this.state.attributes});
		}
	}
	
	componentWillMount() {
		this.props.apiCall("GET", `admin/vendor/${this.props.vendor}`, data => this.setState({vendor: data}));
		
		this.props.apiCall("GET", `admin/import/attributes/${this.props.vendor}`, data =>
			this.setState({
				attributes: mapArrayToObject(data, x => ({
					key: x.id,
					data: objectMerge(x, {options: arrayToObject(x.options)})
				}))
			})
		);
	}
	
	state = {
		vendor: {},
		attributes: {}
	};
	
	render() {
		const {attributes, productTypes: types} = this.props;
		
		let subsections = {};
		forEachObj(this.props.sections, x => x.children.forEach(y => subsections[y.id] = y.title));
		
		return (
			<Fragment>
				<div className="header">
					<span className="vendor">Vendor: {this.state.vendor.name || "Loading..."}</span>
					<Button onClick={this.onSave}>Save</Button>
				</div>
				
				<div className="attributes">
					<AttributeProvider value={{
						subsections, attributes, types,
						onAddAttribute: this.onAddAttribute,
						onAddType: this.onAddType,
						onAttributeChange: this.onAttributeChange,
						onConfChange: this.onConfChange,
						onSectionChange: this.onSectionChange,
						onTypeChange: this.onTypeChange
					}}>
						{mapObjectToArray(this.state.attributes, (x, i) =>
							<ImportAttribute key={x.id} {...x}/>
						)}
					</AttributeProvider>
				</div>
			</Fragment>
		);
	}
}

const ImportAttributeView = reduxWrapper("getApiCall", "loadAttributes", "loadSections", "loadProductTypes", "addProductTypes", "addAttributes", "getSendMessage")(ImportAttributeViewRender);

class ImportAttribute extends React.PureComponent {
	
	state = {
		page: 0
	};
	
	render() {
		const {id, name, options, isConfig, attributeLink} = this.props;
		
		return (
			<div className="attribute">
				<AttributeConsumer>
					{({attributes, onAddAttribute, onConfChange, onAttributeChange}) => (
						<div className="head">
							<span className="name">{name}</span>
							<DropDown title="Attribute" options={attributes} value={attributeLink}
							          onCreate={onAddAttribute}
							          onChange={val => onAttributeChange(id, val)}/>
							<Checkbox title="is configuration" value={isConfig}
							          onChange={val => onConfChange(id, val)}/>
						</div>
					)}
				</AttributeConsumer>
				<div className="paging">
					<Button onClick={() => this.setState(prev => ({page: Math.max(prev.page - 1, 0)}))}>Prev</Button>
					<Button onClick={() => this.setState(prev => ({page: Math.min(prev.page + 1, Math.ceil(objLength(options) / 100) - 1)}))}>Next</Button>
				</div>
				<div className="body">
					{mapObjectToArray(options, x => <ImportOption key={x.id} parentId={id} {...x}/>).slice(this.state.page * 100, this.state.page * 100 + 100)}
				</div>
			</div>
		);
	}
}

class ImportOption extends React.PureComponent {
	render() {
		const {id, name, sections, types, typeId, sectionId, parentId} = this.props;
		
		return (
			<AttributeConsumer>
				{({subsections, types, onAddType, onSectionChange, onTypeChange}) => (
					<div className="option">
						<span className="name">{name}</span>
						<DropDown title="Sections" options={subsections} value={sectionId}
						          onChange={val => onSectionChange(parentId, id, val)}/>
						<DropDown title="Product Types" options={types} value={typeId} onCreate={onAddType}
						          onChange={val => onTypeChange(parentId, id, val)}/>
					</div>
				)}
			</AttributeConsumer>
		);
	}
}

export default ImportTool;


// WEBPACK FOOTER //
// ./src/admin/importTool.js